import { Search, X } from 'lucide-react'
import type { InputHTMLAttributes } from 'react'
import { cn } from '../lib/cn'
import { inputClassName } from './field'

/**
 * Busca única de uma lista de trabalho: cobre nome, CPF, RG, e-mail e telefone.
 * Aparece quando a lista passa de 20 itens. O placeholder diz o que a busca cobre.
 */
export interface SearchInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'onChange'
> {
  value: string
  onChange: (value: string) => void
  onClear?: () => void
}

export function SearchInput({
  value,
  onChange,
  onClear,
  className,
  placeholder = 'Buscar nome, CPF ou telefone',
  ...props
}: SearchInputProps) {
  return (
    <div data-slot="search-input" className={cn('relative min-w-[220px] flex-1', className)}>
      <Search
        aria-hidden
        strokeWidth={1.4}
        className="text-label pointer-events-none absolute top-1/2 left-[14px] size-4 -translate-y-1/2"
      />
      <input
        type="search"
        role="searchbox"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        className={cn(
          inputClassName,
          'pl-10 [&::-webkit-search-cancel-button]:hidden',
          value && 'pr-10',
        )}
        {...props}
      />
      {value ? (
        <button
          type="button"
          aria-label="Limpar busca"
          onClick={() => {
            onChange('')
            onClear?.()
          }}
          className="text-label hover:text-ink absolute top-1/2 right-2 flex size-8 -translate-y-1/2 cursor-pointer items-center justify-center"
        >
          <X aria-hidden strokeWidth={1.4} className="size-4" />
        </button>
      ) : null}
    </div>
  )
}
